import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import Orders from './pages/Orders';
import Inventory from './pages/Inventory';
import InventoryAnalytics from './pages/InventoryAnalytics';
import Reorder from './pages/Reorder';
import RTO from './pages/RTO';
import Expenses from './pages/Expenses';
import PL from './pages/PL';
import PLLock from './components/PLLock';
import TaxExport from './pages/TaxExport';
import Invoices from './pages/Invoices';
import Proforma from './pages/Proforma';
import Settings from './pages/Settings';
import DesignMappings from './pages/DesignMappings';
import BlankMaterialCheck from './pages/BlankMaterialCheck';
import PLExcelCheck from './pages/PLExcelCheck';
import CashFlow from './pages/CashFlow';
import Dispatch from './pages/Dispatch';
import BorrowedStock from './pages/BorrowedStock';
import CustomerRisk from './pages/CustomerRisk';
import UserManagement from './pages/UserManagement';
import PurchaseReceives from './pages/PurchaseReceives';
import AIChat from './components/AIChat';
import Vault from './pages/Vault';
import VaultProfile from './pages/VaultProfile';
import VaultAccount from './pages/VaultAccount';
import AdminRoute from './components/AdminRoute';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <ToastProvider>
        <AuthProvider>
          <AIChat />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
            <Route path="/inventory-analytics" element={<ProtectedRoute><InventoryAnalytics /></ProtectedRoute>} />
            <Route path="/reorder" element={<ProtectedRoute><Reorder /></ProtectedRoute>} />
            <Route path="/rto" element={<ProtectedRoute><RTO /></ProtectedRoute>} />
            <Route path="/customer-risk" element={<ProtectedRoute><CustomerRisk /></ProtectedRoute>} />
            <Route path="/design-mappings" element={<ProtectedRoute><DesignMappings /></ProtectedRoute>} />
            <Route path="/blank-material-check" element={<ProtectedRoute><BlankMaterialCheck /></ProtectedRoute>} />
            <Route path="/pl-excel-check" element={<ProtectedRoute><PLExcelCheck /></ProtectedRoute>} />
            <Route path="/cash-flow" element={<ProtectedRoute><CashFlow /></ProtectedRoute>} />
            <Route path="/borrowed-stock" element={<ProtectedRoute><BorrowedStock /></ProtectedRoute>} />
            <Route path="/dispatch" element={<ProtectedRoute><Dispatch /></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
            <Route path="/pl" element={<ProtectedRoute><PLLock><PL /></PLLock></ProtectedRoute>} />
            <Route path="/tax" element={<ProtectedRoute><TaxExport /></ProtectedRoute>} />
            <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
            <Route path="/proforma" element={<ProtectedRoute><Proforma /></ProtectedRoute>} />
            <Route path="/purchase-receives" element={<ProtectedRoute><PurchaseReceives /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
            <Route path="/vault" element={<ProtectedRoute><AdminRoute><Vault /></AdminRoute></ProtectedRoute>} />
            <Route path="/vault/profiles/:id" element={<ProtectedRoute><AdminRoute><VaultProfile /></AdminRoute></ProtectedRoute>} />
            <Route path="/vault/accounts/:id" element={<ProtectedRoute><AdminRoute><VaultAccount /></AdminRoute></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
